<template>
  <div class="SocialBtnGroup">
    <label v-if="$viewportWidth < 992">Follow us on</label>
    <div class="wrapper">
      <btn class="blue-lochmara" href="https://www.linkedin.com/company/barilla_group/" target="_blank" rel="noopener" icon="linkedin-in"><span v-if="$viewportWidth >= 992">{{this.dataInText}}</span></btn>
      <btn class="blue-lochmara" href="https://twitter.com/barillagroup" target="_blank" rel="noopener" icon="twitter"><span v-if="$viewportWidth >= 992">{{this.dataTtText}}</span></btn>
      <btn class="blue-lochmara" href="https://www.youtube.com/user/BarillaGroup" target="_blank" rel="noopener" icon="youtube"><span v-if="$viewportWidth >= 992">{{this.dataYtText}}</span></btn>
      <btn class="blue-lochmara" href="https://instagram.com/barillapeople/" target="_blank" rel="noopener" icon="instagram"><span v-if="$viewportWidth >= 992">{{this.dataIgText}}</span></btn>
    </div>
  </div>
</template>

<script>
import Btn from '@components/atoms/btn';

export default {
  name: 'SocialBtnGroup',
  components: {Btn},
  props: {
    dataTtText: {
      type: String,
      required: true,
    },
    dataIgText: {
      type: String,
      required: true,
    },
    dataInText: {
      type: String,
      required: true,
    },
    dataYtText: {
      type: String,
      required: true,
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~$scss/variables";

.SocialBtnGroup {
  label {
    display: block;
    color: $color-grey;
    font-size: 20px;
    font-weight: $light;
    line-height: 25px;
    margin-bottom: 25px;
  }

  .wrapper {
    display: flex;

    ::v-deep .Btn {
      margin-right: 20px;

      @media (max-width: $bootstrap-lg - 1px) {
        padding: 22.5px;

        .icon {
          right: auto;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
}
</style>
